// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"006adc01","213":"582a9d7c","239":"ab3f9a9b","453":"eea76131","455":"90daf037","551":"46565025","954":"9b98558b"}[chunkId] + ".chunk.js";
};